import CollabApi from '@/api/collab'
import store from '@/vuex/store'
import constants from '@/constant'

let first = true

const checkCanNotEditSlide = (slideState) => {
  if (store.state.presentation.hasSharedUser && store.state.isDisableEditPresentation) {
    return true
  }
  if (store.state.presentation.accountId && !store.state.presentation.hasSharedUser &&
      store.state.presentation.accountId % 2 === 1 && store.state.isDisableEditPresentation) {
    return true
  }
  const usersOnline = slideState[store.state.slideActive.id]
  if (store.state.currentUser.id && store.state.slideActive.id && usersOnline
    && (store.state.presentation.accountId || store.state.presentation.hasSharedUser)) {
    const index = usersOnline.findIndex(
      (item) => {
        if (!item.user) return false
        return item.user.id === store.state.currentUser.id
      },
    )
    store.state.userEditingSlide = null
    usersOnline.forEach((item) => {
      if (item.user.id !== store.state.currentUser.id && item.isCanEdit) {
        store.state.userEditingSlide = item.user
      }
    })

    if (index !== -1 && !usersOnline[index].isCanEdit) {
      return true
    }
  }
  if (store.state.presentation.accountId &&
    store.state.currentUser.accountRole === constants.workspace.VIEWER) {
    return true
  }
  return false
}

const handleUserInSlides = async (slideState = {}) => {
  if (!store.state.presentation.id || !store.state.currentUser) return
  if (!store.state.presentation.accountId && !store.state.hasSharedUser) return
  const currentUserId = store.state.currentUser.id
  let userInActive = true
  store.state.presentation.slides.forEach((item, index) => {
    if (slideState[item.id]) {
      item.usersOnline = slideState[item.id]
      if (item.usersOnline.find((info) => info.user.id === currentUserId)) {
        userInActive = false
      }
    } else {
      item.usersOnline = null
    }
    store.state.presentation.slides[index] = item
  })
  if (userInActive) {
    store.state.userInactiveReload = true
  }
  store.state.presentation.slides.push()
  store.state.isDisableEditSlide = checkCanNotEditSlide(slideState)
}

const handleActiveSlide = async (mappingUserBySlideId) => {
  const currentUserId = store.state.currentUser.id
  let slideActive = null
  Object.keys(mappingUserBySlideId).forEach((slideId) => {
    mappingUserBySlideId[slideId].forEach((info) => {
      if (info.user.id === currentUserId) {
        slideActive = slideId
      }
    })
  })

  const itemSlideActive = store.state.presentation.Slides.find((slide) => {
    return slide.id === parseInt(slideActive, 10)
  })
  if (itemSlideActive) {
    await store.dispatch(
      'updateSlideActiveAction',
      JSON.parse(JSON.stringify(itemSlideActive)),
    )
  }
}

const getListUsersEditPresentation = async (isUpdateTime = false, forceActiveSlide = false) => {
  if (!store.state.presentation.id) return
  if (store.state.presentation.accountId && !store.state.presentation.hasSharedUser && store.state.presentation.accountId % 2 === 0) {
    const resp = await CollabApi.listUserEditPresentation({
      accessCode: store.state.presentation.uniqueAccessCode,
      userId: store.state.currentUser.id,
      isUpdateTime,
    })
    if (first || forceActiveSlide) {
      await handleActiveSlide(resp.data)
      first = false
    }

    const oldUserOnlineByPresentationId = JSON.parse(JSON.stringify(store.state.userOnlineByPresentationId))
    store.state.userOnlineByPresentationId = null
    await handleUserInSlides(resp.data)
    store.state.userOnlineByPresentationId = oldUserOnlineByPresentationId
    store.state.userOnlineByPresentationId[store.state.presentation.id] = resp.data
  }
}

const handleNextSlideUserCollab = () => {
  const index = store.state.presentation.slides.findIndex(
    (item) => item.id === store.state.slideActive.id,
  )
  if (index !== -1) {
    store.state.presentation.slides.forEach((item) => {
      if (!item.usersOnline) return
      const indexUser = item.usersOnline.findIndex((u) => u.user.id == store.state.currentUser.id)
      if (indexUser !== -1) {
        item.usersOnline.splice(indexUser, 1)
      }
      const data = {
        user: store.state.currentUser,
        lastModified: new Date(),
        isCanEdit: false,
        currentSlideUserActive: store.state.slideActive.id,
      }
      if (!store.state.presentation.slides[index].usersOnline) {
        store.state.presentation.slides[index].usersOnline = []
        data.isCanEdit = true
      }
      store.state.presentation.slides[index].usersOnline.push(data)
    })
  }
}

export default {
  getListUsersEditPresentation,
  handleUserInSlides,
  handleNextSlideUserCollab,
}
